import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-stone-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-stone-900">{t('404.title')}</h1>
        <p className="mt-2 text-base text-stone-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-stone-500">{t('404.subtitle')}</p>
        <a href="/" className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-stone-900 text-white text-sm font-medium rounded-full hover:bg-stone-800 transition-colors">
          {t('404.backHome')}
        </a>
      </div>
    </div>
  );
}